import { mapState, mapActions } from 'vuex'
import PixelSnippet from '@components/embed/PixelSnippet/PixelSnippet.vue'

export default {
  name: 'PixelPresence',
  components: {
    'pixel-snippet-component': PixelSnippet,
  },
  props: {
    targetCampaignID: {
      required: false,
      type: Number,
    },
    hideEmbedDetailsIfFound: {
      required: false,
      type: Boolean,
      default: false,
    },
    showFAQ: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      targetDomainChecked: false,
    }
  },
  computed: {
    ...mapState({
      embedCodeCampaigns: (state) => state.campaign.embedCode.embedCodeCampaigns,
      embedCodeCheckCompleted: (state) => state.campaign.embedCode.embedCodeCheckCompleted,
      embedCodeCheckLoading: (state) => state.campaign.embedCode.embedCodeCheckLoading,
      embedCodeCheckError: (state) => state.campaign.embedCode.embedCodeCheckError,
    }),
    embedCodeCheckWrapperStyling() {
      return this.targetCampaign?.found
        ? this.$style.customDropdownContainer
        : ''
    },
    embedCodeCheckContainerStyling() {
      return this.targetCampaign?.found
        ? this.$style.green
        : this.$style.red
    },
    uniqueCampaigns() {
      const uniqueIds = new Set()
      const filteredCampaigns = this.embedCodeCampaigns.filter(campaign => {
        if (campaign.domainID !== null && !uniqueIds.has(campaign.domainID)) {
          uniqueIds.add(campaign.domainID)
          return true
        }
        return false
      })

      return filteredCampaigns
    },
    targetCampaign() {
      return this.embedCodeCampaigns.find((campaign) => {
        return campaign.campaignID === this.targetCampaignID
      })
    },
    showEmbedDetails() {
      return this.hideEmbedDetailsIfFound ? !this.targetCampaign?.found : true
    },
  },
  methods: {
    ...mapActions('campaign', ['getAllCampaigns']),
    ...mapActions('campaign/embedCode',
      ['checkEmbedCodePresence', 'clearEmbedCodeState']),
    triggerCheckEmbedCodePresence(domainID) {
      const campaign = this.findCampaignByDomainID(domainID)
      const popup = window.open(campaign.domain,
        'popup', 'width=600,height=600')

      if (popup) {
        const checkClosed = setInterval(() => {
          if (popup.closed) {
            // Popup has been closed
            clearInterval(checkClosed)

            this.checkEmbedCodePresence().then(() => {
              this.targetDomainChecked = true
            })
          }
        }, 1000) // Check every second

        // Set a timeout to clear the interval after n seconds
        const timeoutDuration = 10000
        setTimeout(() => {
          clearInterval(checkClosed)
          if (!popup.closed) {
            this.checkEmbedCodePresence().then(() => {
              this.targetDomainChecked = true
            })
          }
        }, timeoutDuration)
      } else {
        // Popup blocked or failed to open
        console.log(
          'Popup failed to open. Please check your popup blocker settings.')
      }
    },
    findCampaignByDomainID(domainID) {
      return this.embedCodeCampaigns.find(
        campaign => campaign.domainID === domainID)
    },
  },
}
